var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgHome03 = function SvgHome03(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 59,
    height: 56,
    viewBox: "0 0 59 56",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.27734 17.054L24.9797 10.2432",
    stroke: "#2F3447",
    strokeMiterlimit: 22.9256,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.8928 7.81079L51.9408 1",
    stroke: "#2F3447",
    strokeMiterlimit: 22.9256,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.6089 55V12.5137",
    stroke: "#2F3447",
    strokeMiterlimit: 22.9256,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4373 55H42.781",
    stroke: "#2F3447",
    strokeMiterlimit: 22.9256,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M28.6089 6.02734C30.51 6.02734 32.0655 7.4868 32.0655 9.27058C32.0655 11.0544 30.51 12.5138 28.6089 12.5138C26.7078 12.5138 25.1523 11.0544 25.1523 9.27058C25.1523 7.4868 26.7078 6.02734 28.6089 6.02734Z",
    stroke: "#2F3447",
    strokeMiterlimit: 22.9256,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M0.783691 41.5405H21.1774",
    stroke: "#2F8BFF",
    strokeMiterlimit: 22.9256,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M1.30244 43.4862C3.20354 46.8916 6.83292 49.4862 10.9808 49.4862C15.1286 49.4862 18.5852 47.0538 20.6591 43.6484C21.3504 42.3511 21.3504 41.5403 20.832 40.0808L12.3634 19.4863C12.1906 19.162 12.0177 18.8376 11.4993 18.6755C10.808 18.5133 10.1166 18.8376 9.94382 19.3241C7.00575 27.4322 4.06768 31.8106 0.956781 39.9187C0.611126 41.3781 0.611126 42.1889 1.30244 43.4862Z",
    stroke: "#2F8BFF",
    strokeMiterlimit: 22.9256,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M36.0403 29.7026H56.4339",
    stroke: "#2F8BFF",
    strokeMiterlimit: 22.9256,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M36.5593 31.6483C38.4604 35.0537 42.0898 37.6483 46.2376 37.6483C50.3855 37.6483 53.842 35.2159 55.916 31.8105C56.6073 30.5132 56.6073 29.7024 56.0888 28.2429L47.6202 7.6484C47.4474 7.32408 47.2746 6.99975 46.7561 6.83759C46.0648 6.67543 45.3735 6.99976 45.2007 7.48624C42.2626 15.5943 39.3245 19.9727 36.2136 28.0808C35.868 29.5402 35.868 30.351 36.5593 31.6483Z",
    stroke: "#2F8BFF",
    strokeMiterlimit: 22.9256,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgHome03, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/home-03.56661bcb.svg";
export { ForwardRef as ReactComponent };